import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import "bulma/css/bulma.css";
import VCalendar from "v-calendar";
import Vuelidate from "vuelidate";
import { store } from "./store/store";

Vue.use(Vuelidate);
Vue.use(VCalendar);

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(axios);

import Home from "./pages/Home.vue";
import Login from "./pages/Login.vue";
import ModuleList from "./pages/ModuleList.vue";
import Module from "./pages/Module.vue";
import Schedule from "./pages/Schedule.vue";
import About from "./pages/About.vue";
import Contact from "./pages/Contact.vue";

const routes = [
  { path: "/", name: "home", component: Home },
  {
    path: "/login",
    name: "login",
    component: Login,
    props: true,
    beforeEnter: (to, from, next) => {
      store.dispatch("clearErrors");
      next();
    }
  },
  {
    path: "/modules",
    name: "moduleList",
    component: ModuleList,
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) next("/login");
      else next();
    }
  },
  {
    path: "/module/:id",
    name: "module",
    component: Module,
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) next("/login");
      else next();
    }
  },
  {
    path: "/schedule",
    name: "schedule",
    component: Schedule,
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) next("/login");
      else next();
    }
  },
  { path: "/about", name: "about", component: About },
  { path: "/contact", name: "contact", component: Contact }
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

new Vue({
  store,
  router
}).$mount("#app");
